<template>
<div>
  <div class="search-wrap">
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
    <el-button size="mini" @click="setCostPrice()">批量设置成本价（默认）</el-button>
    <el-button size="mini" @click="setPrice()">批量设置销售价（默认）</el-button>
    <el-button size="mini" @click="exportExcel()">导出</el-button>
    <el-button size="mini" @click="importExcel()">导入</el-button>
<!--    <el-button size="mini" @click="computeDosageNumber()">生成</el-button>-->
<!--    <el-button size="mini" @click="getExcel()">导出</el-button>-->
    <!--    <el-button size="mini" @click="ocr()">识别</el-button>-->
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '150px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费项目（默认组）">
        <el-select size="mini" style="width: 100%" v-model="where.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准（默认组）">
        <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费项目（第一组）">
        <el-select size="mini" style="width: 100%" v-model="where.one_chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准（第一组）">
        <el-select size="mini" style="width: 100%" v-model="where.one_charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in one_house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费项目（第二组）">
        <el-select size="mini" style="width: 100%" v-model="where.two_chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准（第二组）">
        <el-select size="mini" style="width: 100%" v-model="where.two_charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in two_house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed></el-table-column>
      <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
      <el-table-column prop="number" label="仪表编号"  width="150" align="center" fixed></el-table-column>
      <el-table-column prop="name" label="仪表名称"  width="200" align="center"></el-table-column>
      <el-table-column label="默认单价" align="center">
        <el-table-column prop="hc_name" label="费项名称"  width="250" align="center"></el-table-column>
        <el-table-column prop="price" label="成本单价"  width="120" align="center">
            <template slot="header">
                <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                成本单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="batch-cost_price">批量调整</el-dropdown-item>
                        <el-dropdown-item command="all-cost_price">全部调整</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
          <template slot-scope="scope">
            <input type="number" class="number-input" v-model="scope.row.cost_price" @change="setMeterOrderPrice(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="销售单价"  width="120" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                销售单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-price">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-price">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <input type="number" class="number-input" v-model="scope.row.price" @change="setMeterOrderPrice(scope.row)" />
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="第一组单价（单价按组计算）" align="center">
        <el-table-column prop="one_hc_name" label="费项名称"  width="250" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                费项名称<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-one_charge_id">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-one_charge_id">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="成本单价"  width="120" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                成本单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-one_cost_price">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-one_cost_price">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <input v-if="scope.row.one_charge_id" type="number" class="number-input" v-model="scope.row.one_cost_price" @change="setMeterOrderPrice(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="销售单价"  width="120" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                销售单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-one_price">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-one_price">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <input v-if="scope.row.one_charge_id" type="number" class="number-input" v-model="scope.row.one_price" @change="setMeterOrderPrice(scope.row)" />
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="第二组单价（单价按组计算）" align="center">
        <el-table-column prop="two_hc_name" label="费项名称"  width="250" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                费项名称<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-two_charge_id">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-two_charge_id">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="成本单价"  width="120" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                成本单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-two_cost_price">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-two_cost_price">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <input v-if="scope.row.two_charge_id" type="number" class="number-input" v-model="scope.row.two_cost_price" @change="setMeterOrderPrice(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="销售单价"  width="120" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                销售单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-two_price">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-two_price">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <input v-if="scope.row.two_charge_id" type="number" class="number-input" v-model="scope.row.two_price" @change="setMeterOrderPrice(scope.row)" />
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="ancestor_name" label="房产"  width="320" align="center"></el-table-column>
<!--      <el-table-column prop="chargeItem_name" label="费项类型"  width="150" align="center"></el-table-column>-->
      <el-table-column prop="update_time" label="操作时间"  width="200" align="center"></el-table-column>
      <el-table-column prop="user_name" label="操作人" width="150" align="center"></el-table-column>
      <el-table-column prop="user_name" label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="initMeterOrderPrice(scope.row)">初始单价</el-button>
        </template>
      </el-table-column>

    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
    <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>
  <InputBox ref="inputBoxRef" />
  <SelectCharge ref="SelectChargeRef" />
</div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";
import InputBox from "../../meter_note/components/InputBox";
import SelectCharge from "../components/SelectCharge";
export default {
  name: "MeterOrderItemPrice",
  inject:['mainObj','componentId','setComponentId'],
  components: {InputBox, SelectCharge},
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        chargeItem_name_id:"",
        charging_standard:"",
        one_chargeItem_name_id:"",
        one_charging_standard:"",
        two_chargeItem_name_id:"",
        two_charging_standard:"",
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_item_list: [],
      house_charge_list: [],
      one_house_charge_list:[],
      two_house_charge_list:[],
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
    }
  },
  mounted() {
    const that=this;
    that.getMeterTypeList();
    that.mainObj.project_id&&that.getHouseChargeitemNameList();
    that.mainObj.project_id&&that.getHouseChargeList('',list=>{
      that.house_charge_list=list;
      that.one_house_charge_list=list;
      that.two_house_charge_list=list;
    });
    that.pageChange(1)
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderItemPrice/getOrderList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    setMeterOrderPrice(item){
      const that = this;
      that.$confirm(`您是否确定修改【${item.name}】的计费单价?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = ERP.reJson(item);
        MeterHttp.post("MeterOrderItemPrice/setMeterOrderPrice",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });

      });
    },
    initMeterOrderPrice(item){
      const that = this;
      that.$confirm(`该费项初始化单价：${item.charge_price}元，您是否确定初始化【${item.name}】的计费单价?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = ERP.reJson(item);
        data.price=data.charge_price;
        data.cost_price=data.charge_price;
        MeterHttp.post("MeterOrderItemPrice/setMeterOrderPrice",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });

      });
    },
    setPrice(){
      const that = this;
      if(that.multipleSelection.length==0){
        that.$message({
          type: 'info',
          message: '请先选择要设置的仪表'
        });
        return;
      }
      //弹窗输入金额
      that.$prompt('请输入批量设置的销售单价', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(([1-9]\d*)|0)(\.\d{1,2})?$/,
        inputErrorMessage: '请输入正确的金额'
      }).then(({ value }) => {
        let multipleSelection=that.multipleSelection.map(ret=>{
          return{
            project_id:ret.project_id,
            meter_id:ret.meter_id,
            charge_price:ret.charge_price,
            cost_price:ret.cost_price,
            price:ret.price,
          }
        });
        let data = {
          project_id:that.mainObj.project_id,
          meter_list:JSON.stringify(multipleSelection),
          name:'price',
          value:value,
        }
        MeterHttp.post("MeterOrderItemPrice/setMeterOrderItemPrice",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    setCostPrice(){
      const that = this;
      if(that.multipleSelection.length==0){
        that.$message({
          type: 'info',
          message: '请先选择要设置的仪表'
        });
        return;
      }
      //弹窗输入金额
      that.$prompt('请输入批量设置的成本单价', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(([1-9]\d*)|0)(\.\d{1,2})?$/,
        inputErrorMessage: '请输入正确的金额'
      }).then(({ value }) => {
        let multipleSelection=that.multipleSelection.map(ret=>{
          return{
            project_id:ret.project_id,
            meter_id:ret.meter_id,
            charge_price:ret.charge_price,
            cost_price:ret.cost_price,
            price:ret.price,
          }
        });
        let data = {
          project_id:that.mainObj.project_id,
          meter_list:JSON.stringify(multipleSelection),
          name:'cost_price',
          value:value,
        }
        MeterHttp.post("MeterOrderItemPrice/setMeterOrderItemPrice",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    exportExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderItemPrice/exportMeterOrderItemPriceExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          window.open(res.data)
        }
        that.loading = false;
      })

    },
    importExcel(){
      const that = this;
      MeterHttp.uploadFile(file=>{
        MeterHttp.post("MeterOrderItemPrice/importMeterOrderItemPriceExcel",{
          project_id:that.mainObj.project_id,
          file:file,
          user_type:(that.$route.query.type||0),
        },res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '导入成功!'
            });
            that.getList()
          }else {
            this.$message({
             type: 'info',
            })
          }
        })
      })
    },
    getHouseChargeList(chargeItem_name_ids,callback){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      chargeItem_name_ids&&(where.chargeItem_name_ids=(chargeItem_name_ids+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          // that.house_charge_list=ret.data.list;
          callback&&callback(ret.data.list);
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    handleCommand(command){
      const that = this;
      let command_arr = command.split('-');
      let command_type = command_arr[0];
      let command_field = command_arr[1];

      console.log(command_type,command_field)

      if(['cost_price','price','one_cost_price','one_price','two_cost_price','two_price'].includes(command_field)){
        that.$refs.inputBoxRef.show('number',value=>{
          if(!value){
            that.$message.error('请输入数值');
            return false;
          }
          command_type==='batch'&&that._setOrderKeyValue(command_field,value);
          command_type==='all'&&that.setOrderAllKeyValue(command_field,value);
        });
      }else {
        that.$refs.SelectChargeRef.show(ret=>{
          command_type==='batch'&&that._setOrderKeyValue(command_field,ret.charging_standard);
          command_type==='all'&&that.setOrderAllKeyValue(command_field,ret.charging_standard);
        });
      }
    },
    _setOrderKeyValue(name,value){
      const that = this;
      if(that.multipleSelection.length==0){
        that.$message({
          type: 'info',
          message: '请先选择要设置的仪表'
        });
        return;
      }
      let multipleSelection=that.multipleSelection;
      let data = {
        project_id:that.mainObj.project_id,
        meter_list:JSON.stringify(multipleSelection),
        name:name,
        value:value,
      }
      MeterHttp.post("MeterOrderItemPrice/setMeterOrderItemPrice",data,res=>{
        if (res.code) {
          that.$message({
            type: 'success',
            message: '设置成功!'
          });
          that.getList()
        }else {
          this.$message({
            type: 'info',
            message: res.msg||"修改异常"
          });
        }
      });
    },
    setOrderAllKeyValue(name,value){
      const that = this;
      let where = ERP.reJson(this.where);
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      where.house_name=that.mainObj.house_name;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      MeterHttp.post("MeterOrderItemPrice/setOrderItemPriceKeyValue",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        update_name:name,
        update_value:value,
      },res=>{
        if (res.code) {
          that.getList()
        }
      })
    }

  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    'where.chargeItem_name_id': {
      handler(val, oldVal) {
        const that = this;
        that.where.charging_standard="";
        that.getHouseChargeList(that.where.chargeItem_name_id,list=>that.house_charge_list=list);
      },
      deep: true
    },
    'where.one_chargeItem_name_id': {
      handler(val, oldVal) {
        const that = this;
        that.where.charging_standard="";
        that.getHouseChargeList(that.where.one_chargeItem_name_id,list=>that.one_house_charge_list=list);
      },
      deep: true
    },
    'where.two_chargeItem_name_id': {
      handler(val, oldVal) {
        const that = this;
        that.where.charging_standard="";
        that.getHouseChargeList(that.where.two_chargeItem_name_id,list=>that.two_house_charge_list=list);
      },
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.number-input{
  background-color: #ffe5d5;
  color: black;
  width: 100%;
  &[disabled]{
    background-color: #ececec;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderItemPrice.vue